import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <div className="footer-container">
            <a
                href="https://github.com/sapscode"
                className="footer-link"
                target="_blank"
                rel="noreferrer"
            >
                Click to visit my github profile!
            </a>
        </div>
    );
};

export default Footer;
